import React from "react";
import COLOR from "../../global/Color";
import HeaderContainer from "../../components/header/HeaderContainer";
import HeaderTitle from "../../components/header/HeaderTitle";
import HeaderContent from "../../components/header/HeaderContent";
import HeaderContentSmall from "../../components/header/HeaderContentSmall";
import SubHeading from "../../components/inner/venderProduct/SubHeading";
import SyncommTableBox from "../../components/inner/venderProduct/SyncommTableBox";
import CenterAlignedContainerNoPadding from "../../components/inner/venderProduct/CenterAlignedContainerNoPadding";
import NoPaddingCenterAlignedContainer from "../../components/container/venderProduct/NoPaddingCenterAlignedContainer";
import GoodixTable from "../../components/inner/venderProduct/GoodixTable";
import styled from "styled-components";
import { useLanguage } from "../../context/LanguageContext";
import { siteCopy } from "../../i18n/landingCopy";

import syncommTableImage01 from "../../assets/vendorProduct/syncommTableImage01.png";
import syncommTableImage02 from "../../assets/vendorProduct/syncommTableImage02.png";
import syncommTableImage03 from "../../assets/vendorProduct/syncommTableImage03.png";
import syncommTableImage04 from "../../assets/vendorProduct/syncommTableImage04.png";
import syncommTableImage05 from "../../assets/vendorProduct/syncommTableImage05.png";
import syncommTableImage06 from "../../assets/vendorProduct/syncommTableImage06.png";
import syncommTableImage07 from "../../assets/vendorProduct/syncommTableImage07.png";
import syncommTableImage08 from "../../assets/vendorProduct/syncommTableImage08.png";
import syncommTableImage09 from "../../assets/vendorProduct/syncommTableImage09.png";
import syncommTableImage10 from "../../assets/vendorProduct/syncommTableImage10.png";
import syncommTableImage11 from "../../assets/vendorProduct/syncommTableImage11.png";
import syncommTableImage12 from "../../assets/vendorProduct/syncommTableImage12.png";
import syncommTableImage13 from "../../assets/vendorProduct/syncommTableImage13.png";
import syncommTableImage14 from "../../assets/vendorProduct/syncommTableImage14.png";
import syncommTableImage15 from "../../assets/vendorProduct/syncommTableImage15.png";
import syncommTableImage16 from "../../assets/vendorProduct/syncommTableImage16.png";

const Syncomm = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.vendor?.syncomm || siteCopy.en.pages.vendor.syncomm;
  const imageMap = [
    syncommTableImage01,
    syncommTableImage02,
    syncommTableImage03,
    syncommTableImage04,
    syncommTableImage05,
    syncommTableImage06,
    syncommTableImage07,
    syncommTableImage08,
    syncommTableImage09,
    syncommTableImage10,
    syncommTableImage11,
    syncommTableImage12,
    syncommTableImage13,
    syncommTableImage14,
    syncommTableImage15,
    syncommTableImage16,
  ];

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  const syncommTableItem = (copy.featureItems || []).map((item, index) => ({
    ...item,
    image: imageMap[index],
  }));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <HeaderContent>
          <span style={{ color: COLOR.MAGORELLEBLUE, fontWeight: 700 }}>
            {copy.title}
            <span
              style={{ color: COLOR.BLACK, fontWeight: 300, display: "inline-block" }}
            ></span>
          </span>(
          <a
            style={{ textDecoration: "underline", color: COLOR.BLACK }}
            href={copy.website}
            target="_blank"
          >
            {copy.website}
          </a>
          ) {renderLines(copy.headerIntro)}
        </HeaderContent>

        <HeaderContentSmall>{renderLines(copy.bodyParagraphs)}</HeaderContentSmall>

        <SubHeading>{copy.keyFactorsHeading}</SubHeading>
        <HeaderContentSmall>{renderLines(copy.keyFactorsText)}</HeaderContentSmall>

        <SubHeading>{copy.evaluationHeading}</SubHeading>
        <HeaderContentSmall>{renderLines(copy.evaluationText)}</HeaderContentSmall>
        
        <SubHeading>{copy.partnersHeading}</SubHeading>
        <HeaderContentSmall>{renderLines(copy.partnersText)}</HeaderContentSmall>
      </HeaderContainer>

      <CenterAlignedContainerNoPadding>
        <SyncommTableBox data={syncommTableItem} />
      </CenterAlignedContainerNoPadding>

      <NoPaddingCenterAlignedContainer>
        <ImageBoxContainer>
          <SubHeading>{copy.featureSummaryTitle}</SubHeading>
          <GoodixTable HeaderData={copy.featureSummaryHeader} RowData={copy.featureSummaryRows} />
        </ImageBoxContainer>
      </NoPaddingCenterAlignedContainer>
    </>
  );
};

const ImageBoxContainer = styled.div`
  width: 50%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`;

export default Syncomm;
